var foldFormDataToRequest = function foldFormDataToRequest(formdata, request) {
  request.body = formdata;
};

export default foldFormDataToRequest;